// extracted by mini-css-extract-plugin
export default {"promoHeaderContainer":"styles_promoHeaderContainer__2u+Oc"};